import { vmColor } from "@helpers/themeColor"
import { useTranslation } from "react-i18next"

export default function ForgettingCurveVisual() {
  const { t } = useTranslation()

  return (
    <div className="vm-card w-full p-4">
      <svg className="w-full" viewBox="0 0 320 180">
        {[40, 80, 120].map((y) => (
          <line
            key={y}
            style={{ stroke: vmColor("line") }}
            strokeDasharray="4 4"
            x1="20"
            x2="310"
            y1={y}
            y2={y}
          />
        ))}

        <path
          className="animate-draw"
          d="M20 30 C 60 120, 110 150, 310 158"
          fill="none"
          pathLength={1}
          strokeDasharray="1"
          strokeLinecap="round"
          strokeWidth="4"
          style={{ stroke: vmColor("red") }}
        />

        <path
          className="animate-draw [animation-delay:700ms]"
          d="M20 30 C 50 70, 70 75, 95 50 C 120 80, 140 80, 165 45 C 190 70, 215 70, 240 40 C 260 55, 285 55, 310 35"
          fill="none"
          pathLength={1}
          strokeDasharray="1"
          strokeLinecap="round"
          strokeWidth="4"
          style={{ stroke: vmColor("primary") }}
        />

        {[95, 165, 240].map((x, index) => (
          <circle
            className="animate-scale-in"
            cx={x}
            cy={x === 95 ? 50 : x === 165 ? 45 : 40}
            key={x}
            r="5"
            style={{
              animationDelay: `${1100 + index * 250}ms`,
              fill: vmColor("primary"),
              transformOrigin: "center",
              transformBox: "fill-box",
            }}
          />
        ))}

        <text fontSize="11" style={{ fill: vmColor("muted") }} x="20" y="176">
          {t("pages.onboarding.visuals.forgettingCurve.today")}
        </text>
        <text
          fontSize="11"
          style={{ fill: vmColor("muted") }}
          textAnchor="end"
          x="310"
          y="176"
        >
          {t("pages.onboarding.visuals.forgettingCurve.inAWeek")}
        </text>
      </svg>

      <div className="mt-3 flex flex-wrap justify-center gap-4 text-xs font-semibold">
        <span className="flex items-center gap-1.5 text-vm-red-text">
          <span className="h-2.5 w-2.5 rounded-full bg-vm-red" />
          {t("pages.onboarding.visuals.forgettingCurve.withoutReview")}
        </span>
        <span className="flex items-center gap-1.5 text-vm-primary-text">
          <span className="h-2.5 w-2.5 rounded-full bg-vm-primary" />
          {t("pages.onboarding.visuals.forgettingCurve.withVisualMind")}
        </span>
      </div>
    </div>
  )
}
